import { I18_NEXT_LANG_CHANGED, TRUE } from "shared/constants/strings";

import { PERMISSION_GROUP_ARRAY } from "./constants";
import { PERMISSIONS } from "./types";

const getAllPermissions = () =>
    PERMISSION_GROUP_ARRAY.map(group => group.permissions).flat();

const getDefaultPermissionState = () => {
    const allPermissions = getAllPermissions();

    return allPermissions.reduce<Record<PERMISSIONS, boolean>>(
        (acc, permission) => {
            acc[permission] = false;
            return acc;
        },
        {} as Record<PERMISSIONS, boolean>
    );
};

const createPermissions = (permissionList: PERMISSIONS[] | null) => {
    const initialPermissions = getDefaultPermissionState();
    const currentPermissions = { ...initialPermissions };

    // Grant only the specified permissions
    if (permissionList) {
        permissionList.forEach(permission => {
            currentPermissions[permission] = true;
        });

        return currentPermissions;
    }

    // Grant all permissions if permissionList is null
    Object.keys(currentPermissions).forEach(key => {
        currentPermissions[key as PERMISSIONS] = true;
    });

    return currentPermissions;
};

const handle2FaEnableFlowSeen = (
    is2FaSetupRequired: boolean,
    isEnabled: boolean
) => !is2FaSetupRequired || isEnabled;

const hasLanguageChangedManually = () =>
    localStorage.getItem(I18_NEXT_LANG_CHANGED) === TRUE;

export {
    getAllPermissions,
    getDefaultPermissionState,
    createPermissions,
    handle2FaEnableFlowSeen,
    hasLanguageChangedManually
};
